import { State } from './state'

export class Interactor<S extends State> {
  protected state: S
  constructor(state: S) {
    this.state = state
  }
}
